import { useQuery, useQueryClient } from "@tanstack/react-query";

// Probes the server-side dashboard session. The server is the only authority;
// this hook just reflects whether the current browser holds a valid session
// cookie so the UI can reveal admin navigation.
export function useAdminSession() {
  const { data } = useQuery<{ authed: boolean }>({
    queryKey: ["admin-session"],
    queryFn: async () => {
      const res = await fetch("/api/dashboard/session");
      if (!res.ok) return { authed: false };
      return res.json();
    },
    staleTime: 60_000,
    retry: false,
  });
  return { authed: data?.authed === true };
}

export function useInvalidateAdminSession() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["admin-session"] });
}
